const STEP_0 = [{}];

const ARRAY = [];

const STEP_1_SENIOR = [].concat(
  ...['senior'].map((v) => STEP_0.map((s) => ({ ...s, age: v })))
);
const STEP_1_KID = [].concat(
  ...['kid'].map((v) =>
    STEP_0.map((s) => ({
      ...s,
      age: v,
    }))
  )
);
const STEP_1_STANDARD = [].concat(
  ...['teenager', 'adult'].map((v) =>
    STEP_0.map((s) => ({
      ...s,
      age: v,
    }))
  )
);

const STEP_2_STANDARD = [].concat(
  ...['bluelight', 'sun'].map((v) =>
    STEP_1_STANDARD.map((s) => ({
      ...s,
      screen: v,
    }))
  )
);
const STEP_2_KID = [].concat(
  ...['bluelight', 'sun'].map((v) =>
    STEP_1_KID.map((s) => ({
      ...s,
      screen: v,
    }))
  )
);

const STEP_2_SENIOR_READING = [].concat(
  ...['reading'].map((v) =>
    STEP_1_SENIOR.map((s) => ({
      ...s,
      screen: v,
    }))
  )
);
const STEP_2_SENIOR_STANDARD = [].concat(
  ...['bluelight', 'sun'].map((v) =>
    STEP_1_SENIOR.map((s) => ({
      ...s,
      screen: v,
    }))
  )
);

const STEP_2A_SENIOR_STANDARD_NEED_CORRECTION_YES = [].concat(
  STEP_2_SENIOR_STANDARD.map((s) => ({
    ...s,
    needCorrection: 'yes',
  }))
);
const STEP_2A_SENIOR_STANDARD_NEED_CORRECTION_NO = [].concat(
  STEP_2_SENIOR_STANDARD.map((s) => ({
    ...s,
    needCorrection: 'no',
  }))
);

const STEP_2B_READING_CORRECTION = [].concat(
  ...[ARRAY].map((v) => [
    ...STEP_2_SENIOR_READING.map((s) => ({
      ...s,
      correction: v,
    })),
  ])
);
const STEP_2B_CORRECTION = [].concat(
  ...[ARRAY].map((v) => [
    ...STEP_2A_SENIOR_STANDARD_NEED_CORRECTION_YES.map((s) => ({
      ...s,
      correction: v,
    })),
  ])
);
const STEP_2C_READING_CORRECTION_SCREEN_TIME = [].concat(
  ...[ARRAY].map((v) => [
    ...STEP_2B_READING_CORRECTION.map((s) => ({
      ...s,
      screenTime: v,
    })),
  ])
);

const STEP_3_FORM = [].concat(
  ...[ARRAY].map((v) => [
    ...STEP_2_STANDARD.map((s) => ({
      ...s,
      form: v,
    })),
  ])
);
const STEP_3_FORM_CORRECTION = [].concat(
  ...[ARRAY].map((v) => [
    ...STEP_2C_READING_CORRECTION_SCREEN_TIME.map((s) => ({
      ...s,
      form: v,
    })),
  ])
);
const STEP_3_FORM_NEED_CORRECTION_NO = [].concat(
  ...[ARRAY].map((v) => [
    ...STEP_2A_SENIOR_STANDARD_NEED_CORRECTION_NO.map((s) => ({
      ...s,
      form: v,
    })),
  ])
);
const STEP_3_FORM_NEED_CORRECTION_YES_CORRECTION = [].concat(
  ...[ARRAY].map((v) => [
    ...STEP_2B_CORRECTION.map((s) => ({
      ...s,
      form: v,
    })),
  ])
);

const STEP_4_COLOR = [].concat(
  ...[ARRAY].map((v) => STEP_3_FORM.map((s) => ({ ...s, color: v })))
);
const STEP_4_COLOR_KID = [].concat(
  ...[ARRAY].map((v) => STEP_2_KID.map((s) => ({ ...s, color: v })))
);
const STEP_4_COLOR_CORRECTION = [].concat(
  ...[ARRAY].map((v) => STEP_3_FORM_CORRECTION.map((s) => ({ ...s, color: v })))
);
const STEP_4_COLOR_NEED_CORRECTION_NO = [].concat(
  ...[ARRAY].map((v) =>
    STEP_3_FORM_NEED_CORRECTION_NO.map((s) => ({ ...s, color: v }))
  )
);
const STEP_4_COLOR_NEED_CORRECTION_YES_CORRECTION = [].concat(
  ...[ARRAY].map((v) =>
    STEP_3_FORM_NEED_CORRECTION_YES_CORRECTION.map((s) => ({ ...s, color: v }))
  )
);

const ChristmasConfig = {
  STEP_0,

  STEP_1_SENIOR,
  STEP_1_STANDARD,
  STEP_1_KID,

  STEP_2_STANDARD,
  STEP_2_KID,
  STEP_2_SENIOR_READING,
  STEP_2_SENIOR_STANDARD,
  STEP_2A_SENIOR_STANDARD_NEED_CORRECTION_YES,
  STEP_2A_SENIOR_STANDARD_NEED_CORRECTION_NO,
  STEP_2B_CORRECTION,
  STEP_2B_READING_CORRECTION,
  STEP_2C_READING_CORRECTION_SCREEN_TIME,

  STEP_3_FORM,
  STEP_3_FORM_CORRECTION,
  STEP_3_FORM_NEED_CORRECTION_NO,
  STEP_3_FORM_NEED_CORRECTION_YES_CORRECTION,

  STEP_4_COLOR,
  STEP_4_COLOR_KID,
  STEP_4_COLOR_CORRECTION,
  STEP_4_COLOR_NEED_CORRECTION_NO,
  STEP_4_COLOR_NEED_CORRECTION_YES_CORRECTION,
};

export default ChristmasConfig;
